import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllCategories } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

export const useForceDeleteAllCategories = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllCategoriesMutate,
        isPending: isForceDeleteAll,
    } = useMutation({
        mutationFn: forceDeleteAllCategories,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete categories");
        },
    });

    return {
        forceDeleteAllCategoriesMutate,
        isForceDeleteAll,
    };
};
